import { Button, Card, CardBody, CardHeader, Col, Input, Label, ListGroup, ListGroupItem, Row } from 'reactstrap';
import * as React from 'react';
import { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { FileContext } from './FileContext';
import { FaPlus, FaTimes } from 'react-icons/fa';

interface IProps {
  setIsDirty: Dispatch<SetStateAction<boolean>>;
}

export const Family = (props: IProps) => {
  const fileContext = useContext(FileContext);
  const [changedFamilyLength, setChangedFamilyLength] = useState(0);
  let ref: any = undefined;

  useEffect(() => {
    if (changedFamilyLength > 0) {
      var elmnt = document.getElementById('add-new-family');
      if (elmnt) {
        elmnt.scrollIntoView({ behavior: 'smooth' });
        ref.focus();
      }
    }
  }, [changedFamilyLength]);

  return (
    <>
      <Card>
        <CardHeader className={'d-flex align-items-center'}>Family</CardHeader>
        <CardBody className={'p-0'}>
          <ListGroup flush={true}>
            {fileContext.family.length > 0 && (
              <ListGroupItem className={'py-2 d-none d-md-block'}>
                <Row style={{ paddingRight: 42 }} className='row--condensed'>
                  <Col md={3}>
                    <Label>Name</Label>
                  </Col>
                  <Col md={3}>
                    <Label>Relationship</Label>
                  </Col>
                  <Col md={3}>
                    <Label>Contact Information</Label>
                  </Col>
                  <Col md={3}>
                    <Label>Details</Label>
                  </Col>
                </Row>
              </ListGroupItem>
            )}
            {fileContext.family.map((f, index) => (
              <ListGroupItem key={f.familyId} className='list-group-item--borderless'>
                <div className={'d-flex'}>
                  <Row className={'flex-grow-1 row--condensed'}>
                    <Col md={3}>
                      <Label className={'d-md-none'}>Name</Label>
                      <Input
                        type='text'
                        value={f.name}
                        ref={(r) => {
                          ref = r;
                        }}
                        onChange={(e) => {
                          const nameTemp = e.target.value;
                          fileContext.setFamily((oldF) => [
                            ...oldF.slice(0, index),
                            { ...oldF[index], name: nameTemp },
                            ...oldF.slice(index + 1),
                          ]);
                          props.setIsDirty(true);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Label className={'d-md-none'}>Relationship</Label>
                      <Input
                        type='text'
                        value={f.relationship}
                        onChange={(e) => {
                          const relationshipTemp = e.target.value;
                          fileContext.setFamily((oldF) => [
                            ...oldF.slice(0, index),
                            { ...oldF[index], relationship: relationshipTemp },
                            ...oldF.slice(index + 1),
                          ]);
                          props.setIsDirty(true);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Label className={'d-md-none'}>Contact Information</Label>
                      <Input
                        type='text'
                        value={f.contactInformation}
                        onChange={(e) => {
                          const contactInformationTemp = e.target.value;
                          fileContext.setFamily((oldF) => [
                            ...oldF.slice(0, index),
                            { ...oldF[index], contactInformation: contactInformationTemp },
                            ...oldF.slice(index + 1),
                          ]);
                          props.setIsDirty(true);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Label className={'d-md-none'}>Details</Label>
                      <Input
                        type='text'
                        value={f.details}
                        onChange={(e) => {
                          const detailsTemp = e.target.value;
                          fileContext.setFamily((oldF) => [
                            ...oldF.slice(0, index),
                            { ...oldF[index], details: detailsTemp },
                            ...oldF.slice(index + 1),
                          ]);
                          props.setIsDirty(true);
                        }}
                      />
                    </Col>
                    <Col className={'d-md-none mt-3'}>
                      <Button
                        color='danger'
                        className='w-mobile-100'
                        onClick={() => {
                          props.setIsDirty(true);
                          fileContext.setFamily((oldF) => [...oldF.slice(0, index), ...oldF.slice(index + 1)]);
                        }}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>

                  <div className={'d-none d-md-block'} style={{ width: 42 }}>
                    <Button
                      color={'link'}
                      className={'text-danger'}
                      onClick={() => {
                        props.setIsDirty(true);
                        fileContext.setFamily((oldFS) => [...oldFS.slice(0, index), ...oldFS.slice(index + 1)]);
                      }}
                    >
                      <FaTimes />
                    </Button>
                  </div>
                </div>
              </ListGroupItem>
            ))}
            <ListGroupItem
              tag={'button'}
              id={'add-new-family'}
              className='border-top'
              onClick={() => {
                props.setIsDirty(true);
                fileContext.setFamily((f) =>
                  f.concat([
                    {
                      familyId: Math.random().toString(),
                      name: '',
                      relationship: '',
                      contactInformation: '',
                      details: '',
                    },
                  ])
                );
                setChangedFamilyLength((f) => f + 1);
              }}
            >
              <FaPlus /> Add Family
            </ListGroupItem>
          </ListGroup>
        </CardBody>
      </Card>
    </>
  );
};
